import { v4 as uuid } from 'uuid';

import { CHANGE_V2_CURRENT_DATE } from '../constants';
import { CHANGE_STATUS, LIFECYCLE_STEP, TChangeV2, URGENCY } from '../models';
import { deriveRequestId } from './automationRules';

// Builds a blank in-memory Change in Draft. A request id is available immediately;
// the human-readable Change ID is only assigned when the request is submitted.
export const createBlankChange = (initiator: string, overrides: Partial<TChangeV2> = {}): TChangeV2 => {
  const nowIso = new Date().toISOString();
  const requestDateIso = CHANGE_V2_CURRENT_DATE.toISOString();
  const { id: overrideId, requestId: overrideRequestId, ...recordOverrides } = overrides;
  const id = overrideId ?? uuid();
  const requestId = overrideRequestId ?? deriveRequestId(id, overrides.displayId);

  return {
    id,
    requestId,
    displayId: undefined,
    title: '',
    status: CHANGE_STATUS.DRAFT,
    lifecycleStep: LIFECYCLE_STEP.REQUEST,
    initiator,
    changeManager: undefined,
    createdAt: nowIso,
    requestDate: requestDateIso,
    targetDate: undefined,
    changeCategory: undefined,
    changeType: undefined,
    scopeType: undefined,
    criticality: undefined,
    urgency: URGENCY.NORMAL,
    description: '',
    reasonOrTrigger: '',
    desiredOutcome: undefined,
    implementationProposal: undefined,
    affectedProducts: [],
    affectedProductFamilies: [],
    affectedQmsAreas: [],
    sourceRecord: undefined,
    knownSafetyConcern: undefined,
    safetyConcernDescription: undefined,
    knownAffectedDocuments: [],
    relatedChanges: [],
    collaborators: [],
    attachments: [],
    capaRequired: undefined,
    capaId: undefined,
    progress: 0,
    blockers: [],
    nextAction: 'Complete and submit the request',
    currentOwner: initiator,
    awaitingExternalDecision: false,
    template: undefined,
    assessorFunctions: [],
    immediateContainment: { required: false },
    workflowRoute: [],
    returnInfo: undefined,
    duplicateInfo: undefined,
    rejectInfo: undefined,
    auditEvents: [],
    comments: [],
    tasks: [],
    ...recordOverrides,
  };
};
